import { memo, useEffect, useCallback, useState } from "react";
import { getPedigree } from "../../api";
import { Text, View, Page, Document, PDFViewer, Image } from '@react-pdf/renderer';
import "./Fonts.js";
import styles from "./Styles.js";
import { SheepBoilerplate } from "./SheepBoilerplate.js";
import Logo from "../../assets/images/logo-white-first.png";

const Pedigree = ({
    selectedOwner,
    selectedAnimal
}) => {
    const [fetchedPedigree, setFetchedPedigree] = useState([]);

    const fetchData = useCallback(
        async () => {
            try {
                const { pedigree } = await getPedigree(selectedOwner._id, selectedAnimal.flockCode);
                setFetchedPedigree(pedigree)
                console.log(pedigree)
            } catch (error) {
                console.log(error)
            }
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <PDFViewer style={{ width: '85vw', height: '100vh' }}>
                <Document>
                    <Page size='A4' style={styles.page} wrap>
                        <View style={styles.container}>
                            {/* Header */}
                            <View style={styles.header} wrap={false}>
                                <View wrap={false}>
                                    <Image style={styles.logo} src={Logo} />
                                </View>
                                <View style={{ width: '30%' }} wrap={false}>
                                    <Text style={styles.headerText}>{fetchedPedigree?.organization}</Text>
                                </View>
                            </View>
                            {/* Owner Info */}
                            <View style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} wrap={false}>
                                <View style={styles.ownerContainer} wrap={false}>
                                    <View style={styles.ownerContainerCell} wrap={false}>
                                        <View style={styles.ownerContainerHeaderText} wrap={false}>
                                            <Text>{'Εκτροφή'}</Text>
                                        </View>
                                        <View style={styles.ownerContainerCellText} wrap={false}>
                                            <Text>{`${fetchedPedigree?.owner?.owner}`}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.ownerContainerCell} wrap={false}>
                                        <View style={styles.ownerContainerHeaderText} wrap={false}>
                                            <Text>{'Κωδικός'}</Text>
                                        </View>
                                        <View style={styles.ownerContainerCellText} wrap={false}>
                                            <Text>{fetchedPedigree?.owner?.code}</Text>
                                        </View>
                                    </View>
                                    <View style={[styles.ownerContainerCell, { borderBottom: '0' }]} wrap={false}>
                                        <View style={styles.ownerContainerHeaderText} wrap={false}>
                                            <Text>{'Διεύθυνση - Πόλη'}</Text>
                                        </View>
                                        <View style={styles.ownerContainerCellText} wrap={false}>
                                            <Text>{`${fetchedPedigree?.owner?.addressCity}`}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            {/* Sheep Info */}
                            <SheepBoilerplate data={fetchedPedigree?.animal} title='Στοιχεία Προβάτου' />
                            {/* Sire Info */}
                            <SheepBoilerplate data={fetchedPedigree?.animalSire} title='Στοιχεία Πατέρα Προβάτου' />
                            <View style={{ position: 'relative', left: '7%' }}>
                                {/* Sire's Sire Info */}
                                <SheepBoilerplate data={fetchedPedigree?.animalSireSire} title='Στοιχεία Πατέρα Πατέρα Προβάτου' />
                                {/* Sire's Mother Info */}
                                <SheepBoilerplate data={fetchedPedigree?.animalSireDam} title='Στοιχεία Μητέρας Πατέρα Προβάτου' />
                            </View>
                            {/* Dam Info */}
                            <SheepBoilerplate data={fetchedPedigree?.animalDam} title='Στοιχεία Μητέρας Προβάτου' />
                            <View style={{ position: 'relative', left: '7%' }}>
                                {/* Dams's Sire Info */}
                                <SheepBoilerplate data={fetchedPedigree?.animalDamSire} title='Στοιχεία Πατέρα Πατέρα Προβάτου' />
                                {/* Dams's Mother Info */}
                                <SheepBoilerplate data={fetchedPedigree?.animalDamDam} title='Στοιχεία Μητέρας Πατέρα Προβάτου' />
                            </View>
                            {/* Children Info */}
                            {fetchedPedigree?.offsprings?.map((offspring, index) =>
                                <SheepBoilerplate key={index} data={offspring} title={`Στοιχεία Απογόνου ${index + 1}`} />,
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    )
};

export default memo(Pedigree)